import React from "react";
import "../styles/portfolio.css";
import {BsGithub} from 'react-icons/bs'
import witw from "../images/WITW.JPG"
import advc from "../images/advc.JPG"
import MSF from "../images/MultiStepForm.JPG"
import tracker from "../images/tracker.JPG"
import notesApp from '../images/NotesApp.JPG'
import shopping from '../images/shopping.JPG'
import github_users from '../images/github_users.JPG'
import kanban from '../images/kanban.jpg'

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>Practice Projects</h5>
      <h2>Projects</h2>
      <div className="projects_container">
        <div className="project_card">
          <div className="project_img_container">
            <img src={kanban} alt="project snapshot" className="project_img" />
          </div>
          <h3>Kanban Board - React App</h3>
          <div className="project_links">
            <a href="https://github.com/samReacts/Kanban-Board" target='_blank' className="btn"><BsGithub/>  &nbsp;GitHub</a>
            <a href="https://samreacts.github.io/Kanban-Board" className="btn btn-primary" target='_blank'>Live Demo</a>
          </div>
        </div>
        <div className="project_card">
          <div className="project_img_container">
            <img src={shopping} alt="project snapshot" className="project_img" />
          </div>
          <h3>Shopping App Project</h3>
          <div className="project_links">
            <a href="https://github.com/samReacts/shopping" className="btn" target='_blank'><BsGithub/>  &nbsp;GitHub</a>
            <a href="https://samReacts.github.io/shopping/" className="btn btn-primary" target='_blank'>Live Demo</a>
          </div>
        </div> 
        <div className="project_card">
          <div className="project_img_container">
            <img src={witw} alt="project snapshot" className="project_img" />
          </div>
          <h3>Where in the World!</h3>
          <div className="project_links">
            <a href="https://github.com/samReacts/Where-in-the-World" target='_blank' className="btn"><BsGithub/>  &nbsp;GitHub</a>
            <a href="https://samReacts.github.io/Where-in-the-World/" className="btn btn-primary" target='_blank'>Live Demo</a>
          </div>
        </div>
        <div className="project_card">
          <div className="project_img_container">
            <img src={MSF} alt="project snapshot" className="project_img" />
          </div>
          <h3>Multi-Step Form</h3>
          <div className="project_links">
            <a href="https://github.com/samReacts/FrontEndMentor-multi-step-form" className="btn" target='_blank'><BsGithub/>  &nbsp;GitHub</a>
            <a href="https://samreacts.github.io/FrontEndMentor-multi-step-form" className="btn btn-primary" target='_blank'>Live Demo</a>
          </div>
        </div>
        {/* <div className="project_card">
          <div className="project_img_container">
            <img src={advc} alt="project snapshot" className="project_img" />
          </div>
          <h3>Advice Generator</h3>
          <div className="project_links">
            <a href="https://github.com/samReacts/advice-generator" className="btn" target='_blank'><BsGithub/>  &nbsp;GitHub</a>
            <a href="https://samReacts.github.io/advice-generator/" target='_blank' className="btn btn-primary">Live Demo</a>
          </div>
        </div> */}
        <div className="project_card">
          <div className="project_img_container">
            <img src={notesApp} alt="project snapshot" className="project_img" />
          </div>
          <h3>Notes App with React JS</h3>
          <div className="project_links">
            <a href="https://github.com/samReacts/Notes-React-App" className="btn" target='_blank'><BsGithub/>  &nbsp;GitHub</a>
            <a href="https://notesreactjs.netlify.app/" className="btn btn-primary" target='_blank'>Live Demo</a>
          </div>
        </div>
        
        <div className="project_card">
          <div className="project_img_container">
            <img src={github_users} alt="project snapshot" className="project_img" />
          </div>
          <h3>Github Profiles</h3>
          <div className="project_links">
            <a href="https://github.com/samReacts/github-profiles" className="btn" target='_blank'><BsGithub/>  &nbsp;GitHub</a>
            <a href="https://samReacts.github.io/github-profiles/" className="btn btn-primary" target='_blank'>Live Demo</a>
          </div>
        </div> 
        
        <div className="project_card">
          <div className="project_img_container">
            <img src={tracker} alt="project snapshot" className="project_img" />
          </div>
          <h3>Activity Tracker</h3>
          <div className="project_links">
            <a href="https://github.com/samReacts/Frontend-Mentor-TimeTracking" className="btn" target='_blank'><BsGithub/>  &nbsp;GitHub</a>
            <a href="https://samReacts.github.io/Frontend-Mentor-TimeTracking/" className="btn btn-primary" target='_blank'>Live Demo</a>
          </div>
        </div>
               
      </div>
    </section>
  );
};

export default Portfolio;
